import React, { useContext, useEffect, useState } from "react";
import { NavigateButtonsContext, DataUserContext } from "../../../Criare";

import { Back, Hero, LinearGradient, Next } from "../../../../components";

import { Container, Section, NavigateButtons } from "./styles";
import EmailValidator from "../../../../utils/email-validation";
import { ThemeContext, DefaultTheme } from "styled-components";
import { sendPersonalData } from "../../../../services/data-service/api";
import eventTypes from "../../../../events/event-types.const";
import HistoryPages from "../../../../events";
import can from "../../../../utils/can";

const Question04: React.FC = () => {
  const { next } = useContext(NavigateButtonsContext);
  const { userName, homeIgnored, token } = useContext(DataUserContext);
  const [error, setError] = useState(0);

  const [requirementsFulfilled, setRequirementsFulfilled] =
    useState<boolean>(false);

  const [isTermsAccepted, setIsTermsAccepted] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [placeHolder, setPlaceHolder] = useState<string>("");

  useEffect(() => {
    homeIgnored ? setPlaceHolder("Qual o seu melhor e-mail para entrarmos em contato?") : setPlaceHolder("Para qual e-mail devemos enviar o resultado?")
    
    if (isTermsAccepted && EmailValidator(email))
      setRequirementsFulfilled(true);
    else setRequirementsFulfilled(false);
  }, [isTermsAccepted, email]);

  function submit() {
    if (requirementsFulfilled) {
      sendPersonalData({ email }, token);

      if (homeIgnored) {
        next(7);
      } else {
        next(6);
      }
    } else {
      setError((prevState) => prevState + 1);
    }
  }

  const _theme = useContext(ThemeContext);
  const [theme, setTheme] = useState({} as DefaultTheme);

  useEffect(() => {
    if (_theme.steps) setTheme(_theme);
  }, [_theme]);

  useEffect(() => {
    HistoryPages.emit(eventTypes.SAVE, 5);
  }, []);

  return (
    <>
      {theme.status === "success" && (
        <Container>
          <Hero
            criare
            image={can(
              theme,
              "theme.steps.etapa_email.propriedades.imagens.etapa_email_imagemBanner.url"
            )}
            title={can(
              theme,
              "theme.steps.etapa_email.propriedades.banner.tituloBanner"
            )}
            superscript={theme.steps.etapa_email.propriedades.banner.subtituloBanner.replace(
              /{nome}/,
              userName
            )}
          />

          <Section>
            <p>
              {can(
                theme,
                "theme.steps.etapa_email.propriedades.conteudo.titulo"
              )}
              ​
            </p>
            <input
              placeholder={placeHolder}
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            <div>
              <input
                type="checkbox"
                id="terms"
                checked={isTermsAccepted}
                onChange={() => {
                  setIsTermsAccepted((prevState) => !prevState);
                }}
              />
              <label htmlFor="terms">
                Aceito os{" "}
                <a
                  href={can(
                    theme,
                    "theme.steps.etapa_email.propriedades.conteudo.link_politica_privacidade"
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  termos de uso e política de privacidade
                </a>
              </label>
            </div>
          </Section>

          <NavigateButtons>
            <Back criare onClick={() => next(HistoryPages.getLastPage())} />
            <Next criare onClick={submit} animationTrigger={error} />
          </NavigateButtons>

          <LinearGradient />
        </Container>
      )}
    </>
  );
};

export default Question04;
